const ROUND_UP_AFTER_SECONDS = 55;

/**
 * Drops a duration's seconds for display in whole minutes, rounding up to the next minute after 55
 * seconds. A minute that rounds up to 60 carries into the hours, and 24 hours into the days.
 *
 * Durations shown in minutes refresh on a timer that can lag the real elapsed time by a few seconds,
 * so rounding up near the end of a minute shows the user a more accurate value at that fidelity.
 */
export function roundDurationToMinutes(duration: Duration): Duration {
    let minutes = duration.minutes ?? 0;
    let hours = duration.hours ?? 0;
    let days = duration.days ?? 0;
    if ((duration.seconds ?? 0) > ROUND_UP_AFTER_SECONDS) {
        minutes += 1;
    }
    if (minutes === 60) {
        minutes = 0;
        hours += 1;
    }
    if (hours === 24) {
        hours = 0;
        days += 1;
    }
    return {
        years: duration.years ?? 0,
        months: duration.months ?? 0,
        days,
        hours,
        minutes,
    };
}
